<template>
  <div class="w12 confirm-page">
    <mypage-header> </mypage-header>

    <div class="authAddr-container">
      <div class="search-wrap">
        <!-- 검색 조건 받아놓은 데이터에서 필터 걸기 -->
        <el-input
          v-model="searchAddr"
          type="text"
          placeholder="별명, 네트워크로 검색"
          clearable
          @input="searchWallet(searchAddr)"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <div v-if="setAddrLists.length > 0" class="list-wrap mt10">
        <div
          v-for="(list, index) in setAddrLists"
          :key="index"
          class="addr-lists"
        >
          <div class="top-content">
            <div class="title-wrap" flex>
              <div class="title">
                <b flex>
                  <span> [{{ getChannel(list.channel) }}]</span>
                  <span class="nickName">{{ list.nick }}</span>
                </b>
                <div class="status" :class="{ disabled: list.status !== 'E' }">
                  {{ getStatus(list.status) }}
                </div>
              </div>
            </div>
            <div @click="clickMenu(list)" class="icon-menu">
              <img src="~@/assets/img/authAddr/icon-menu.svg" alt="" />
            </div>
          </div>
          <p class="mid-content sub-text networkCi">
            {{ getNetworkCi(list.cidx) }}
          </p>
          <p class="bottom-content sub-text">{{ list.address }}</p>
        </div>
      </div>
      <div v-if="setAddrLists.length === 0" class="noti-wrap">
        <p class="ta-c">{{ "개인지갑 주소란?" }}</p>
        <div class="contents-box">
          <ul>
            <li>
              {{ "개인지갑은 점유 인증이 완료된 주소입니다." }}
            </li>
            <li>
              {{
                "지갑 등록 후 자유롭게 입출금 서비스를 이용하실 수 있습니다."
              }}
            </li>
            <li>
              {{ "지갑 등록은 PC에서 가능합니다." }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <button-modal
      :title="buttonModalTitle"
      :data="menuButtonData"
      @move-to="moveToDetail"
    ></button-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import Api from "@/common/Api.js";
import Moment from "moment";
import axios from "axios";

import MypageHeader from "./component/mypage/header.vue";
import buttonModal from "./component/buttonModal.vue";
import { authIDModal } from "@/common/authIdModal.js";

export default {
  components: {
    MypageHeader,
    buttonModal,
  },
  created() {
    this.getAddresses();
    this.getNetworkInfo();
  },
  mounted() {
    authIDModal(this.userInfo);
  },
  data() {
    return {
      searchAddr: "",
      addrLists: [],
      searchLists: [],
      selectedList: {},
      menuButtonData: {
        showButtonModal: false,
        closeButtonModal: false,
        buttons: [
          {
            name: "별칭 수정",
            type: "edit",
          },
          {
            name: "주소 삭제",
            type: "delete",
          },
        ],
      },
      networkInfo: [],
      network: "",
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
    setAddrLists() {
      if (!this.searchAddr) {
        return this.addrLists;
      } else {
        return this.searchLists;
      }
    },
    buttonModalTitle() {
      return "관리";
    },
  },
  methods: {
    async getAddresses() {
      try {
        const res = await Api.authAddr.getAddresses();
        this.addrLists = res.body;
      } catch (error) {
        this.$vs.notify({
          title: "오류",
          text: error.msg,
          position: "top-right",
          color: "danger",
        });
      }
    },
    getChannel(channel) {
      switch (channel) {
        case "M":
          return "메타마스크";
        case "C":
          return "카카오페이";
        case "P":
          return "페이코인월렛";

        default:
          break;
      }
    },
    getStatus(status) {
      switch (status) {
        case "R":
          return "인증필요";
        case "A":
          return "심사중";
        case "E":
          return "등록완료";
        case "J":
          return "등록반려";

        default:
          break;
      }
    },
    clickMenu(list) {
      this.menuButtonData.showButtonModal = true;
      this.selectedList = list;
    },
    searchWallet(addr) {
      if (addr.length > 0) {
        const newAddLists = new Array();
        this.addrLists.filter((list) => {
          if (list.nick.toUpperCase().indexOf(addr.toUpperCase()) !== -1) {
            newAddLists.push(list);
          }
          if (list.ciCode.toUpperCase().indexOf(addr.toUpperCase()) !== -1) {
            newAddLists.push(list);
          }
          if (list.ciName.toUpperCase().indexOf(addr.toUpperCase()) !== -1) {
            newAddLists.push(list);
          }
        });
        let resLists = [...new Set(newAddLists)]; // 중복 제거: Set 객체는 유니크한 값만을 담음
        this.searchLists = resLists;
      }
    },
    moveToDetail(type) {
      const params = {
        addrInfo: this.selectedList,
        networkInfo: this.network,
        acaidx: this.selectedList.acaidx,
      };
      this.$router.push({
        name: type === "edit" ? "editWallet" : "deleteWallet",
        params,
      });
    },
    async getNetworkInfo() {
      const isDevServer = window.location.host === "m.flybit.com";
      const res = await axios.get(
        `https://third${isDevServer ? "" : ".dev"}.flybit.com/metamask/list`
      );

      this.networkInfo = res.data.result;
    },
    getNetworkCi(cidx) {
      const networkInfo = _.find(this.networkInfo, (ele) => ele.cidx === cidx);
      if (networkInfo) {
        this.network = `${networkInfo.networkName}(${networkInfo.networkCi})`;
        return `${networkInfo.networkName}(${networkInfo.networkCi})`;
      }
      return;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "/src/styles/import.scss";

.authAddr-container {
  position: relative;
  min-height: calc(100% - 160px);
  padding: 16px;
  font-size: 14px;
  word-break: break-all;
  .addr-lists {
    padding: 20px 0 10px;
    border-bottom: 1px solid $BlueGray600;
    /* &:last-of-type {
      border-bottom: none;
    } */
  }
  .search-wrap {
    i.el-input__icon {
      &.el-icon-search {
        &:before {
          content: "";
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 18px;
          height: 18px;
          background-image: url("../../assets/img/authAddr/icon-search.svg");
          background-size: 18px 18px;
          background-repeat: no-repeat;
        }
      }
    }
  }
  .list-wrap {
    margin-top: 10px;
    .addr-lists {
      .top-content {
        position: relative;
        display: flex;
        align-items: center;
        .title-wrap {
          .title {
            display: flex;
            align-items: center;
            margin-bottom: 15px;
            font-size: 16px;
            .nickName {
              max-width: 160px;
              margin-left: 5px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            @media (max-width: 375px) {
              display: block;
              .status {
                width: fit-content;
                margin: 5px 0 10px;
              }
              .nickName {
                max-width: 160px;
                margin-left: 5px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
          }
          .status {
            padding: 2px;
            margin-left: 10px;
            border: 1px solid $Red500;
            border-radius: 4px;
            color: $Red500;
            &.disabled {
              border: 1px solid $WarmBlack500;
              color: $BlueGray600;
            }
          }
        }
        .icon-menu {
          position: absolute;
          top: 0;
          right: 0;
        }
      }
    }
  }
  .sub-text {
    color: $WarmBlack500;
    &.networkCi {
      color: $Red500;
    }
  }
  .noti-wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    padding: 16px;
    font-size: 14px;
    .contents-box {
      padding: 16px;
      margin-top: 12px;
      background-color: $BlueGray300;
      ul {
        list-style: none;
        li {
          position: relative;
          padding: 0 0 10px 10px;
          &:before {
            content: "";
            position: absolute;
            top: 6px;
            left: 0;
            width: 4px;
            height: 4px;
            border-radius: 4px;
            background-color: $WarmBlack700;
          }
        }
      }
    }
  }
}
</style>
